module.exports = __webpack_public_path__ + "static/avtar-8aada56e9f3286ce83e6780540743803.png";